var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgReSmsContentIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.2917 0.621497V4C10.2917 7.06058 12.7728 9.54167 15.8334 9.54167H19.2119C19.292 9.88582 19.3334 10.2406 19.3334 10.5997V16.8333C19.3334 19.4107 17.244 21.5 14.6667 21.5H5.33335C2.75602 21.5 0.666687 19.4107 0.666687 16.8333V5.16667C0.666687 2.58934 2.75602 0.5 5.33335 0.5H9.23369C9.59275 0.5 9.94754 0.541379 10.2917 0.621497ZM12.0417 1.43932V4C12.0417 6.09408 13.7393 7.79167 15.8334 7.79167H18.394C18.2639 7.61894 18.1212 7.45452 17.9665 7.29983L12.5335 1.86683C12.3788 1.71215 12.2144 1.56945 12.0417 1.43932ZM4.45835 11C4.45835 10.5168 4.8501 10.125 5.33335 10.125H10C10.4833 10.125 10.875 10.5168 10.875 11C10.875 11.4832 10.4833 11.875 10 11.875H5.33335C4.8501 11.875 4.45835 11.4832 4.45835 11ZM5.33335 14.7917C4.8501 14.7917 4.45835 15.1834 4.45835 15.6667C4.45835 16.1499 4.8501 16.5417 5.33335 16.5417H14.6667C15.1499 16.5417 15.5417 16.1499 15.5417 15.6667C15.5417 15.1834 15.1499 14.7917 14.6667 14.7917H5.33335Z",
    fill: "#6B7DE5"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgReSmsContentIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/RE_SMS_content_icon.aa70a5d707403edba6d3a30eda0426bd.svg";